import { render, staticRenderFns } from "./QImage2.vue?vue&type=template&id=140283e6&"
import script from "./QImage2.vue?vue&type=script&lang=js&"
export * from "./QImage2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports